import { Model } from 'modules/core/lib/mobx-rest'

import type { IPreference } from './IPreference'

export default class UserPreference extends Model<IPreference> {
  static urlRoot() {
    return '/notifications/user_preferences'
  }

  get notifier(): string {
    return this.get('notifier')
  }

  get channel(): string {
    return this.get('channel')
  }

  get isEnabled(): boolean {
    return this.get('value')
  }

  async updateValue(newValue: boolean) {
    this.set({ value: newValue })

    await UserPreference.create({
      notifier: this.notifier,
      channel: this.channel,
      value: newValue,
    })
  }
}
